import Base from '@/plugins/Base';
const module = {
    namespaced: true,
    state: () => ({
        formData: {},
    }),
    getters: {
        formData() {
            return Base.LocalStorage.get('roomReservationData')
        },
    },
    mutations: {
        setFormData(state, formData) {
            Base.LocalStorage.set('roomReservationData', formData);
            state.formData = formData;
        },
        clearFormData(state) {
            Base.LocalStorage.remove('roomReservationData');
            state.formData = {};
        },
    },
    actions: {
        saveFormData({ commit }, formData) {
            commit('setFormData', formData);
        },
        deleteFormData({ commit }) {
            commit('clearFormData');
        },
    },
};


export default module;
